import { Input, Slider } from '@dc-shared-web/components/shadcn'

const SliderRow = ({
  label,
  value,
  disabled,
  onChange,
}: {
  label: string
  value: number
  disabled?: boolean
  onChange: (value: number) => void
}) => {
  return (
    <div className='tw-flex tw-gap-1 tw-items-center'>
      <div className='tw-text-sm tw-min-w-[105px]'>{label}</div>
      <Slider
        value={[value]}
        min={0}
        max={1}
        step={0.1}
        disabled={disabled}
        onValueChange={(v) => onChange(v[0])}
        className='tw-grow'
      />
      <Input
        type='number'
        value={value.toString()}
        step={0.1}
        disabled={disabled}
        onChange={(e) => onChange(parseFloat(e.target.value))}
        className='tw-min-w-[88px] tw-ml-2'
      />
    </div>
  )
}

export default SliderRow
